<template>
  <b-modal
    id="sample-modal"
    v-model="show"
    size="lg"
    @close="onCancel"
    no-close-on-backdrop
    hide-header-close
    no-close-on-esc
  >
    <template v-slot:modal-title>Send Message Sample</template>

    <div v-if="!inprogress" class="w-100 text-center mb-2">
      Please enter the phone numbers in separate rows.
    </div>

    <div v-if="inprogress">
      <table class="table" v-if="contactList.length > 0">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">
              <div class="form-check">
                <input
                  type="checkbox"
                  name="active"
                  v-model="isPersonsAll"
                  @click="checkAllPersons()"
                  :disabled="loading"
                  id="contacts"
                />
              </div>
            </th>
            <th scope="col">Mobile Number</th>
            <th scope="col">Message Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in contactList" :key="index">
            <th scope="row" v-text="index + 1"></th>
            <td>
              <div class="form-check">
                <input
                  type="checkbox"
                  name="active"
                  v-model="item.checked"
                  @change="updateCheck()"
                  :disabled="loading"
                  :id="item.id"
                />
              </div>
            </td>
            <td v-text="item.mobile"></td>
            <td class="w-25">
              <span :class="getStatusClass(item.status)">
                <em :class="getStatusIconClass(item.status)"></em
                >{{ item.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!inprogress" class="text-center">
      <textarea v-model="phoneNumberList" rows="5" cols="40"></textarea>
      <div v-if="error" style="color: red">{{ error }}</div>
    </div>
    <template v-slot:modal-footer>
      <p v-if="showMessage"><span v-text="$t('messages.more_than_ten')"></span></p>
      <b-button @click="onCancel" :disabled="loading" variant="secondary"
        >Cancel</b-button
      >
      <b-button
        @click="onOk"
        v-if="contactList.length == 0"
        variant="primary"
        >{{ "OK" }}</b-button
      >
      <b-button
        @click="onSend"
        v-if="contactList.length !== 0"
        :disabled="loading"
        variant="success"
        >{{ "Send" }}</b-button
      >
    </template>
  </b-modal>
</template>
<script>
import MessagesApi from "../../../apis/MessagesApi";
import { useManageAttributes } from "../../../stores/manage-attributes";
export default {
  props: {
    messageId: String | Number,
  },
  data() {
    return {
      cloning: false,
      show: false,
      createdMessageId: null,
      contactList: [],
      resolve: null,
      reject: null,
      instanceId: window.Laravel.selected_instance
        ? window.Laravel.selected_instance.id
        : null,
      eTag: null,
      isPersonsAll: false,
      useManageAttributes: useManageAttributes(),
      loading: false,
      loadPersons: false,
      phoneNumberList: "",
      error: "",
      inprogress: false,
      showMessage: false,
    };
  },
  methods: {
    showMoreThanTen() {
      this.showMessage = true;
      setTimeout(() => {
        this.showMessage = false;
      }, 3000);
    },
    async onSend() {
      this.loading = true;
      for (const item of this.contactList) {
        if (item.checked) {
          item.status = "In-Progress";
          try {
            item.status = await this.recipientResponse(item);
            // Handle success
          } catch (error) {
            // Handle failure
            item.status = "Failed";
          }
        }
      }
      this.loading = false;
    },
    onOk() {
      let numbers = this.phoneNumberList.split("\n").map((num) => num.trim());

      // Check if any line has multiple numbers or is empty
      if (
        numbers.some((num) => num.split(/\s+/).length > 1 && num.trim() !== "")
      ) {
        this.error = "Please enter each phone number in a separate row.";
        return;
      }

      // Validate phone numbers
      const validNumbers = numbers.filter((num) => {
        return /^\+?[0-9]*$/.test(num); // regex to accept empty string or only digits
      });

      if (validNumbers.length !== numbers.length) {
        this.error = "Please enter valid phone numbers.";
        return;
      }

      this.error = "";
      this.inprogress = true;
      numbers = numbers.filter((element) => element !== "");
      if (numbers.length > 10) {
        this.showMoreThanTen();
      }
      numbers = numbers.slice(0, 10);
      this.contactList = numbers.map((mobile) => {
        return {
          mobile: mobile,
          checked: true,
          status: "Ready",
        };
      });
    },
    async recipientResponse(contact) {
      return new Promise((resolve, reject) => {
        let attrs = {
          destinationNumber: contact.mobile,
          messageTemplateId: this.messageId,
          messageType: "TRANSACTIONAL",
        };
        let payload = {
          payload: attrs,
        };

        MessagesApi.sendMessage(payload, this.instanceId)
          .then((r) => {
            resolve(this.handleResponse(r));
          })
          .catch((e) => {
            e.response && e.response.data ? reject(e.response.data.error) : reject("Failed");
          });
      });
    },
    handleResponse(response) {
      if (response.code === 200 && response.result.errors.length == 0) {
        return response.result.detail;
      } else {
        if (response.result.errors.length > 0) {
          return response.result.errors[0].errorDescription;
        } else {
          return "Unknown error occurred";
        }
      }
    },
    open() {
      this.phoneNumberList = "";
      this.contactList = [];
      this.error = "";
      this.inprogress = false;
      this.isPersonsAll = true;
      this.disableClose = true;
      this.show = true;
    },
    updateCheck() {
      this.isPersonsAll = this.contactList.every((item) => item.checked);
    },
    onCancel() {
      this.show = false;
      this.disableClose = false;
    },
    checkAllPersons() {
      this.isPersonsAll = !this.isPersonsAll;
      this.contactList.forEach((item) => (item.checked = this.isPersonsAll));
    },
    getStatusClass(status) {
      switch (status) {
        case "Ready":
          return "text-secondary";
        case "In-Progress":
          return "text-info";
        case "Success":
          return "text-success";
        default:
          return "text-info";
      }
    },
    getStatusIconClass(status) {
      switch (status) {
        case "In-Progress":
          return "fa fa-gear fa-spin mr-2";
        case "Success":
          return "fa fa-check-circle mr-2";
        default:
          return "fa fa-info-circle mr-2";
      }
    },
  },
};
</script>
